import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {RelatedBusinessProcessConfig} from '../../Models/relatedBusinessProcessConfig';

@Injectable({
  providedIn: 'root'
})
export class InstanceDistributionConfigService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getInstanceClassification() {
    return this.http.get<any[]>('/api/instanceDistributionConfig/get');
  }

  updateInstanceClassification(instanceClassification) {
    return this.http.post<any>('api/instanceDistributionConfig/update', instanceClassification);
  }
}
